'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Logo = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  ', '\n  transform: rotate(0.0001deg);\n  background: ', ';\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n'], ['\n  width: 100%;\n  height: 100%;\n  ', '\n  transform: rotate(0.0001deg);\n  background: ', ';\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Logo = exports.Logo = _styledComponents2.default.div(_templateObject, '' /* Fixes cutoff edges problem in MS Edge*/, function (props) {
  return props.theme.logo[props.variant];
});
Logo.displayName = 'Logo';


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-logo/styles.js
// module id = 3016
// module chunks = 4